import React, { useMemo } from 'react';

import { useGetRoles } from '@vlabs/api/artemy/client';
import type { RoleId } from '@vlabs/api/artemy/model';
import { FilterRoleByNameInput, useRoleListFilters, SortRoleListDropdown } from '@vlabs/monokit/entities/roles';
import { CreateRoleButton } from '@vlabs/monokit/features/point/create-role';
import { PageHeader, PageSubheader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { withPermissions } from '@vlabs/permissions';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, useHistory } from 'react-router-dom';

import st from './RoleListPageHeader.module.sass';
import { useRoleListPageTranslation } from '../i18n';

const CreateRoleWithAccess = withPermissions('roles', 'create')(CreateRoleButton);

function RoleListPageHeader(): React.JSX.Element {
  const { t } = useRoleListPageTranslation();
  const history = useHistory();
  const pageCtx = usePageContext();
  const { filters } = useRoleListFilters();
  const getRoles = useGetRoles(filters);
  const $title = useMemo(() => (
    <div className={st.Title}>
      {pageCtx.getTitleComponent(t('title'))}
      <FilterRoleByNameInput size={pageCtx.inputSize} />
    </div>
  ), [t, pageCtx]);

  const handleCreateRole = (roleId: RoleId): void => {
    history.push(generatePath(routes.roles.view, { roleId }));
  };

  return (
    <React.Fragment>
      <PageHeader
        actions={(
          <CreateRoleWithAccess
            onCreateRole={handleCreateRole}
            size={pageCtx.buttonSize}
          />
        )}
        title={$title}
      />
      <PageSubheader
        className={st.Subheader}
        title={(
          <div className={st.Count}>
            {t('roles_found', { count: getRoles.data?.roles?.length ?? 0 })}
          </div>
        )}
      >
        <div className={st.SubheaderContent}>
          <div className={st.SubheaderActions}>
            <SortRoleListDropdown />
          </div>
        </div>
      </PageSubheader>
    </React.Fragment>
  );
}

export { RoleListPageHeader };
